import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_2 = { class: "p-jobsearch-search_section_inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "企業の特性", -1)
const _hoisted_4 = { class: "p-jobsearch-search_checklist" }
const _hoisted_5 = ["value", "checked", "onChange"]

import { JobSearchPublicDropdownData } from '@/types/mstMyPage';
import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkCnd',
  props: {
    selectedValues: null
  },
  emits: ['update:selectedValues'],
  setup(__props: any, { emit }) {

const props = __props as { selectedValues?: number[] }

const storeBase = MYPAGE_CONSTANTS.STORE_MST;

// 親コンポーネントにイベントを発行するための宣言


// 親コンポーネントからselectedValuesを受け取るためのprops宣言


const listWorkCnd = ref<JobSearchPublicDropdownData[]>([]);

// チェックボックスの変更を処理する関数
const handleCheckboxChange = (cnd: JobSearchPublicDropdownData) => {
  // チェックボックスの状態を切り替え
  cnd.selected = !cnd.selected;

  // 選択された値の配列を更新
  updateSelectedValues();
};

// 選択された値の配列を更新し、親コンポーネントに送信する関数
const updateSelectedValues = () => {
  // 選択された項目の値を抽出
  const newValues = listWorkCnd.value.filter(item => item.selected).map(item => item.value);

  // 親コンポーネントに選択された値を送信
  emit('update:selectedValues', newValues);
};

const store = useStore();
onMounted(async () => {
  const workCnd = await store.dispatch(storeBase.MST_FEATURES);
  listWorkCnd.value = workCnd;

  // 初期状態で選択されている項目があれば、props.selectedValuesを反映
  updateSelectedFromProps();
});

// props.selectedValuesの変更を監視し、チェック状態を更新
const updateSelectedFromProps = () => {
  if (!listWorkCnd.value.length) return;
  listWorkCnd.value.forEach(item => {
    item.selected = props.selectedValues?.includes(Number(item.value));
  });
};

// props.selectedValuesが変更されたらチェック状態を反映
watch(() => props.selectedValues, () => {
  updateSelectedFromProps();
});

// listWorkCndの変更を監視し、props.selectedValuesを反映
watch(listWorkCnd, () => {
  updateSelectedFromProps();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listWorkCnd.value, (cnd) => {
          return (_openBlock(), _createElementBlock("label", {
            key: cnd.id
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              value: cnd.value,
              checked: cnd.selected,
              onChange: ($event: any) => (handleCheckboxChange(cnd))
            }, null, 40, _hoisted_5),
            _createElementVNode("span", null, _toDisplayString(cnd.text), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})